export const routes = {
  home: "/",
  formation: "/training-programs",
  process: "/admission-process",
  community: "/community",
  auth: "/auth/",
  login: "login",
  register: "register",
  confirmEmail: "/account/activation/:token",
  resetPassword: "password/reset/:token",
  forgotPassword: "forgot-password",
  application: {
    application: "/application",
  },

  dashboard: {
    defaultPath: "/dashboard/",
    statistic: {
      name: "Satistique",
      path: "statistic",
      icon: "pi pi-chart-bar",
    },
    users: {
      name: "Utilisateurs",
      path: "users",
      icon: "pi pi-users",
    },
    candidates: {
      name: "Candidats",
      path: "candidates",
      icon: "pi pi-briefcase",
    },
    mycandidates: {
      name: "Mes Candidatures",
      path: "my-candidates",
      icon: "pi pi-wallet",
    },
    candidateArchives: {
      name: "Candidats",
      path: "candidates/archives",
      icon: "pi pi-wallet",
    },
    singleCandidates:{
      name: "Candidat",
      path: "candidates/:id",
      icon: "pi pi-wallet",
    },
    profil: {
      name: "Profil",
      path: "profil",
      icon: "pi pi-user",
    },

    setting: {
      name: "Parametrage",
      path: "parametrage",
      icon: "pi pi-cog",
    },

    role: {
      name: "Roles",
      path: "roles",
      icon: "pi pi-lock",
    },

    permission: {
      name: "Permissions",
      path: "permissions",
      icon: "pi pi-key",
    },
    requirement: {
      name: "Requirements",
      path: "requirements",
      icon: "pi pi-key",
    },
    generalTest: {
      name: "GeneralTest",
      path: "generalTest",
      icon: "pi pi-key",
    },
    trainings: {
      name: "Parcours",
      path: "trainings",
      icon: "pi pi-key",
    },
    branches: {
      name: "Sites",
      path: "sites",
      icon: "pi pi-key",
    },
    sites: {
      name: "Sites - Parcours",
      path: "sites-trainings/:id",
      icon: "pi pi-key",
    },
    proposals: {
      name: "Propositions de réponses",
      path: "generalTest/:id/proposals",
      icon: "pi pi-key",
    },
  },
  notFound: "*",
  forbidden: "/acces-denied",
};
